import React, { useState } from 'react';
import Product from './Product';

function ShoppingCart() {
	const [products, setProducts] = useState([
		{ id: 1, name: 'Apple', price: '$1' },
		{ id: 2, name: 'Banana', price: '$2' }
	]);

	const handleRemove = productId => {
		setProducts(products.filter(product => product.id !== productId));
	};

	return (
		<div>
			{products.map(product => (
				<Product key={product.id} product={product} onRemove={handleRemove} />
			))}
		</div>
	);
}

export default ShoppingCart